/** F.5.10 + F.5.11 — impls Webhook + Meta + Alerta (Camada 4). */
import type { WebhookSubscriptionGateway } from '@/application/port/out/WebhookSubscriptionGateway';
import type { WebhookDeliveryGateway } from '@/application/port/out/WebhookDeliveryGateway';
import type { MetaVendasGateway } from '@/application/port/out/MetaVendasGateway';
import type { AlertaVendaGateway } from '@/application/port/out/AlertaVendaGateway';
import type {
  WebhookSubscription, WebhookSubscriptionCommand, WebhookDelivery, WebhookDeliveryStatus,
} from '@/domain/model/Webhook';
import type { MetaVendas, MetaVendasCommand, MetaEscopo } from '@/domain/model/MetaVendas';
import type {
  AlertaVenda, AlertaVendaStatus, DeferirAlertaCommand, IndeferirAlertaCommand,
} from '@/domain/model/AlertaVenda';
import type { Page } from '@/domain/model/Page';
import type {
  ListWebhookSubscriptionsUseCase, GetWebhookSubscriptionUseCase,
  CriarWebhookSubscriptionUseCase, AtualizarWebhookSubscriptionUseCase, DesativarWebhookSubscriptionUseCase,
  ListWebhookDeliveriesUseCase, ReplayWebhookDeliveryUseCase,
  ListMetasVendasUseCase, GetMetaVendasUseCase,
  CriarMetaVendasUseCase, AtualizarMetaVendasUseCase, DesativarMetaVendasUseCase,
  ListAlertasVendaUseCase, GetAlertaVendaUseCase,
  DeferirAlertaVendaUseCase, IndeferirAlertaVendaUseCase,
} from '@/application/port/in/Camada4UseCase';

export class ListWebhookSubscriptions implements ListWebhookSubscriptionsUseCase {
  constructor(private readonly gw: WebhookSubscriptionGateway) {}
  execute(p: { ativo?: boolean; page?: number; size?: number }): Promise<Page<WebhookSubscription>> { return this.gw.list(p); }
}
export class GetWebhookSubscription implements GetWebhookSubscriptionUseCase {
  constructor(private readonly gw: WebhookSubscriptionGateway) {}
  execute(id: string): Promise<WebhookSubscription> { return this.gw.get(id); }
}
export class CriarWebhookSubscription implements CriarWebhookSubscriptionUseCase {
  constructor(private readonly gw: WebhookSubscriptionGateway) {}
  execute(c: WebhookSubscriptionCommand): Promise<WebhookSubscription> { return this.gw.criar(c); }
}
export class AtualizarWebhookSubscription implements AtualizarWebhookSubscriptionUseCase {
  constructor(private readonly gw: WebhookSubscriptionGateway) {}
  execute(id: string, c: WebhookSubscriptionCommand): Promise<WebhookSubscription> { return this.gw.atualizar(id, c); }
}
export class DesativarWebhookSubscription implements DesativarWebhookSubscriptionUseCase {
  constructor(private readonly gw: WebhookSubscriptionGateway) {}
  execute(id: string): Promise<void> { return this.gw.desativar(id); }
}

export class ListWebhookDeliveries implements ListWebhookDeliveriesUseCase {
  constructor(private readonly gw: WebhookDeliveryGateway) {}
  execute(p: { status?: WebhookDeliveryStatus; page?: number; size?: number }): Promise<Page<WebhookDelivery>> { return this.gw.list(p); }
}
export class ReplayWebhookDelivery implements ReplayWebhookDeliveryUseCase {
  constructor(private readonly gw: WebhookDeliveryGateway) {}
  execute(id: string): Promise<WebhookDelivery> { return this.gw.replay(id); }
}

export class ListMetasVendas implements ListMetasVendasUseCase {
  constructor(private readonly gw: MetaVendasGateway) {}
  execute(p: { escopo?: MetaEscopo; ativo?: boolean; page?: number; size?: number }): Promise<Page<MetaVendas>> { return this.gw.list(p); }
}
export class GetMetaVendas implements GetMetaVendasUseCase {
  constructor(private readonly gw: MetaVendasGateway) {}
  execute(id: string): Promise<MetaVendas> { return this.gw.get(id); }
}
export class CriarMetaVendas implements CriarMetaVendasUseCase {
  constructor(private readonly gw: MetaVendasGateway) {}
  execute(c: MetaVendasCommand): Promise<MetaVendas> { return this.gw.criar(c); }
}
export class AtualizarMetaVendas implements AtualizarMetaVendasUseCase {
  constructor(private readonly gw: MetaVendasGateway) {}
  execute(id: string, c: MetaVendasCommand): Promise<MetaVendas> { return this.gw.atualizar(id, c); }
}
export class DesativarMetaVendas implements DesativarMetaVendasUseCase {
  constructor(private readonly gw: MetaVendasGateway) {}
  execute(id: string): Promise<void> { return this.gw.desativar(id); }
}

export class ListAlertasVenda implements ListAlertasVendaUseCase {
  constructor(private readonly gw: AlertaVendaGateway) {}
  execute(p: { status?: AlertaVendaStatus; vendedorUserId?: string; page?: number; size?: number }): Promise<Page<AlertaVenda>> { return this.gw.list(p); }
}
export class GetAlertaVenda implements GetAlertaVendaUseCase {
  constructor(private readonly gw: AlertaVendaGateway) {}
  execute(id: string): Promise<AlertaVenda> { return this.gw.get(id); }
}
export class DeferirAlertaVenda implements DeferirAlertaVendaUseCase {
  constructor(private readonly gw: AlertaVendaGateway) {}
  execute(id: string, c: DeferirAlertaCommand): Promise<AlertaVenda> { return this.gw.deferir(id, c); }
}
export class IndeferirAlertaVenda implements IndeferirAlertaVendaUseCase {
  constructor(private readonly gw: AlertaVendaGateway) {}
  execute(id: string, c: IndeferirAlertaCommand): Promise<AlertaVenda> { return this.gw.indeferir(id, c); }
}
